import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Modal from "react-modal";
import "../../../styles/Buttons.css";
import "../../../styles/Containers.css";
import "../../../styles/Fonts.css";
import "../../../styles/Colors.css";
import TopNavbarBack from "../../../components/TopNavbarBack";
import { useFetch } from "../../../custom/api";
import account from "../../../media/account.png";
import network from "../../../media/network.png";
import Transaction from "./Transaction";
import { toFarsiNumber } from "../../../custom/helpers";

export default function Account() {
  const { myFetch } = useFetch();
  let userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [name, setName] = useState("");
  
  const [trackId, setTrackId] = useState("");
  const [startAt, setStartAt] = useState("");
  const [endAt, setEndAt] = useState("");
  const [price, setPrice] = useState("");
  const [planName, setPlanName] = useState("");
  const [transactions, setTransactions] = useState([]);
  
  const [displayName, setDisplayName] = useState(name);
  const [dClassName, setDClassName] = useState('dNone');

  useEffect(() => {
    const fetchData = async () => {
      const resp = await myFetch("account", { method: "GET" });
      const r = await resp.json();
      setName(r[0].name)
      setDisplayName(r[0].name)
      setTransactions(r)
    };
    fetchData();
  }, []);

  useEffect(() => {
    console.log({name, displayName})
    if (name === displayName) {
      setDClassName('dNone')
    } else {
      setDClassName('')
    };
    
  }, [displayName])

  const setModalData = (transactionId) => {
    let transaction = transactions.filter((e) => {
      return e.transaction_id == transactionId
    })[0]


    let options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };

    let startJalali
    let endJalali

    if (transaction.start_at) {
      startJalali = new Date(transaction.start_at).toLocaleDateString('fa-IR', options);
    } else {
      startJalali = '-'
    }

    if (transaction.end_at) {
      endJalali = new Date(transaction.end_at).toLocaleDateString('fa-IR', options);
    } else {
      endJalali = '-'
    }

    let finalPrice
    if (transaction.verify_amount) {
      finalPrice = toFarsiNumber(transaction.verify_amount / 10000)  + ' هزار تومان'
    }else {
      finalPrice = toFarsiNumber(transaction.price)  + ' هزار تومان'
    }
        
    setTrackId(toFarsiNumber(transaction.track_id))
    setStartAt(startJalali)
    setEndAt(endJalali)
    setPrice(finalPrice)
    setPlanName(transaction.name_1)
  }



  const handleNameChange = (e) => {
    setDisplayName(e.target.value);
  };

  const handleNamePress = (e) => {
    if (e.key === "Enter") {
      sendNameToServer();
    }
  };

  const handleNameClick = () => {
    sendNameToServer();
  };

  const sendNameToServer = () => {
    console.log(`Sending name: ${name}`);
  };

  const [showModal, setShowModal] = useState(false);

  const handleOpenCModal = () => {
    setShowModal(true);
  };

  const handleCloseCModal = () => {
    setShowModal(false);
  };

  const textRef = useRef(null);

  const handleCopyClick = () => {};

  return (
    <div className="backLightColor">

      <TopNavbarBack
        title=""
        rbuttonIcon={["icon-iconchevron-right"]}
        rbackground={["rectangle1"]}
        lbuttonIcon={["dNone"]}
        lbuttonHref={["null"]}
        lbackground={["null"]}
      />

      <img src={account} alt="account" className="width100 z-index-1" />

      <div className="main-container">
<div className="resFlex">
        <div className="b-white padding5 radius1-5 shadow-smooth">
          <p className="rightAlign yekan purple-1 caption-1">اطلاعات کاربری</p>
          <div className="spc-between">
            <p className="marginTop3 yekan caption-1">نام:</p>
            <input
              type="text"
              value={displayName}
              onChange={handleNameChange}
              onKeyDown={handleNamePress}
              placeholder="چی صدا کنیم تو رو؟"
              className="yekan caption-1"
            />
            <button
              onClick={handleNameClick}
              className={`sendBtn icon-icondone ${dClassName}`}
            ></button>
          </div>
          <div className="spc-between">
            <p className="marginTop3 yekan caption-1">شماره:</p>
            <input
              type="text"
              value={userInfo.phone_number}
              className="yekan caption-1 b-white"
              disabled
            />
          </div>
        </div>

        <div className="b-white padding5 radius1-5 shadow-smooth marginBottom60">
          <p className="rightAlign yekan purple-1 caption-1">تراکنش‌ها</p>
          <Transaction transactions={transactions} handleOpenCModal={handleOpenCModal} setModalData={setModalData}></Transaction>
        </div>
</div>
      </div>

      <Modal
        isOpen={showModal}
        onRequestClose={handleCloseCModal}
        contentLabel="package info"
        className="modal"
        overlayClassName="overlay"
      >
        <div className="b-white radius2 marginBottom0-4r b-grey-5">
          <div className="width100">
            <div className="marginSide10 centerAlign b-white radius1 paddingSide14 marginTop10">
              <h3>{planName}</h3>
              {/* <h5 className="grey-2">فعال تا {endAt}</h5> */}
            </div>
          </div>
          <div className="marginSide10 marginTop10">
            <div
              className="centerAlign spc-between paddingSide5 marginTop5"
              onClick={handleCopyClick}
            >
              <p className="yekan caption-1">کد پیگیری</p>
              <p className="grey-2 yekan caption-1" ref={textRef}>
                {trackId}
              </p>
            </div>
            <div className="centerAlign spc-between paddingSide5 marginTop5">
              <p className="yekan caption-1">تاریخ شروع</p>
              <p className="grey-2 yekan caption-1">{startAt}</p>
            </div>
            <div className="centerAlign spc-between paddingSide5 marginTop5">
              <p className="yekan caption-1">تاریخ پایان</p>
              <p className="grey-2 yekan caption-1">{endAt}</p>
            </div>
            <div className="centerAlign spc-between paddingSide5 marginTop5">
              <p className="yekan caption-1">قیمت نهایی</p>
              <p className="grey-2 yekan caption-1">{price}</p>
            </div>
          </div>
          <img src={network} alt="network" className="width100 padding10" />
        </div>

        <div className="modal-footer">
          <Link
            to=""
            onClick={handleCloseCModal}
            className="b-purple-1 white fill-container radius1-5"
          >
            بستن
          </Link>
        </div>
      </Modal>
    </div>
  );
}
